import type * as React from 'react';
import { useEffect } from 'react';

// eslint-disable-next-line monorepo/forbidden-imports
import { BrazeProvider } from '@xing-com/braze';
import type { Message, TransportLayer } from '@xing-com/braze';
import type { CrateBrazeContext } from '@xing-com/crate-common-braze';
import { brazeCardHandler, BRAZE_CONTEXT } from '@xing-com/crate-common-braze';
import { useContext } from '@xing-com/crate-xinglet';
import type { Xinglet } from '@xing-com/crate-xinglet';

import LandingPageContent from './landing-page-content';

const subscribeToBraze = (
  ttt: TransportLayer,
  event: string,
  callback: (context: CrateBrazeContext, message: Message) => void,
  context: CrateBrazeContext
): void => {
  ttt.subscribe(event, (message: Message) => {
    callback(context, message);
  });
};

export default class Braze implements Xinglet {
  public createContexts(
    publish: (contextId: string, contextValue: unknown) => void
  ): void {
    const defaultContext: CrateBrazeContext = {
      cards: [],
      ttt: null,
    };
    publish(BRAZE_CONTEXT, defaultContext);
  }

  public getComponent(): React.ComponentType<{
    ttt: TransportLayer;
    section?: string;
  }> {
    return ({ ttt, section = 'wbm/Notifications' }) => {
      const ctx = useContext<CrateBrazeContext>(BRAZE_CONTEXT);

      useEffect(() => {
        subscribeToBraze(ttt, 'stm:braze', brazeCardHandler, ctx);
        ctx.ttt = ttt;
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);

      return (
        <BrazeProvider transportLayer={ttt} section={section}>
          <LandingPageContent />
        </BrazeProvider>
      );
    };
  }
}
